<template>
  <b-container fluid class="links">
    <b-row no-gutters>
      <b-col v-show="bigScreen">
        <ul class="links__list">
          <li class="links__list-item links__list-item--header">Encontre seu curso</li>
          <li class="links__list-item">
            <a class="links__link" href="/busca-cursos/resultados">
              Busque por Curso
            </a>
          </li>
          <li class="links__list-item">
            <a class="links__link" href="/faculdades-e-universidades">
              Lista de Faculdades
            </a>
          </li>
          <li class="links__list-item">
            <a class="links__link" href="/cursos-e-faculdades">
              Lista de Cursos
            </a>
          </li>
          <li class="links__list-item">
            <a class="links__link" href="/carreiras-e-profissoes/todas">
              Lista de Profissões
            </a>
          </li>
          <li class="links__list-item">
            <a class="links__link" target="_blank" rel="noopener" href="/idiomas?utm_source=querobolsa&utm_medium=referral&utm_campaign=link-footer">
              Cursos de Idiomas
            </a>
          </li>
          <li class="links__list-item">
            <a class="links__link" href="/cursos-livres">
              Cursos Livres
            </a>
          </li>
          <li class="links__list-item">
            <a class="links__link" href="/ead-a-distancia">
              Cursos EaD
            </a>
          </li>
          <li class="links__list-item">
            <a class="links__link" href="/cursos-tecnologos">
              Cursos Tecnólogos
            </a>
          </li>
          <li class="links__list-item">
            <a class="links__link" href="/pos-graduacao">
              Cursos Pós-Graduação
            </a>
          </li>
        </ul>
      </b-col>
      <b-col v-show="bigScreen">
        <ul class="links__list">
          <li class="links__list-item links__list-item--header">Central de Ajuda</li>
          <li class="links__list-item">
            <a class="links__link" href="/o-que-e-o-quero-bolsa">
              O que é o Quero Bolsa
            </a>
          </li>
          <li class="links__list-item">
            <a class="links__link" href="/como-funciona">
              Passo a Passo
            </a>
          </li>
          <li class="links__list-item">
            <a class="links__link" href="/perguntas-frequentes">
              Perguntas Frequentes
            </a>
          </li>
          <li class="links__list-item">
            <a class="links__link" href="/politica_de_privacidade">
              Política de Privacidade
            </a>
          </li>
          <li class="links__list-item">
            <a class="links__link" href="/termos_e_condicoes">
              Termos e Condições
            </a>
          </li>
          <li class="links__list-item">
            <a class="links__link" href="/educamaisbrasil">
              Vs Educa Mais Brasil
            </a>
          </li>
          <li class="links__list-item">
            <a class="links__link" href="/maisestudo-neora">
              Vs Mais Estudo/Neora
            </a>
          </li>
        </ul>
      </b-col>
      <b-col v-show="bigScreen">
        <ul class="links__list">
          <li class="links__list-item links__list-item--header">Programas do Governo</li>
          <li class="links__list-item">
            <a class="links__link" href="/programas-do-governo">
              Notas de corte
            </a>
          </li>
          <li class="links__list-item">
            <a class="links__link" href="/enem/o-que-e-quem-pode#o-que-e">
              Enem
            </a>
          </li>
          <li class="links__list-item">
            <a class="links__link" href="/prouni/o-que-e-quem-pode#o-que-e">
              Prouni
            </a>
          </li>
          <li class="links__list-item">
            <a class="links__link" href="/sisu/o-que-e-quem-pode#o-que-e">
              Sisu
            </a>
          </li>
          <li class="links__list-item">
            <a class="links__link" href="/fies/o-que-e-quem-pode#o-que-e">
              Fies
            </a>
          </li>
          <li class="links__list-item">
            <a class="links__link" href="/encceja">
              Encceja
            </a>
          </li>
        </ul>
      </b-col>
      <b-col v-show="bigScreen" class="d-none d-lg-block">
        <ul class="links__list">
          <li class="links__list-item links__list-item--header">Revista Quero</li>
          <li class="links__list-item">
            <a class="links__link" href="/revista/assunto/vestibular-e-enem">
              Vestibular e Enem
            </a>
          </li>
          <li class="links__list-item">
            <a class="links__link" href="/revista/assunto/dicas-e-curiosidades">
              Dicas e Curiosidades
            </a>
          </li>
          <li class="links__list-item">
            <a class="links__link" href="/revista/assunto/especiais">
              Especiais
            </a>
          </li>
          <li class="links__list-item">
            <a class="links__link" href="/revista/assunto/profissoes">
              Profissões
            </a>
          </li>
          <li class="links__list-item">
            <a class="links__link" href="/revista/assunto/pos-graduacao">
              Pós-Graduação
            </a>
          </li>
          <li class="links__list-item">
            <a class="links__link" href="/revista/assunto/idiomas">
              Idiomas
            </a>
          </li>
          <li class="links__list-item">
            <a class="links__link" href="/enem/manual-do-enem">
              Manual do Enem
            </a>
          </li>
          <li class="links__list-item">
            <a class="links__link" href="/enem/gabarito">
              Gabarito do Enem
            </a>
          </li>
        </ul>
      </b-col>
      <b-col v-show="bigScreen">
        <ul class="links__list">
          <li class="links__list-item links__list-item--header">Institucional</li>
          <li class="links__list-item">
            <a class="links__link" href="https://jobs.lever.co/quero.education">
              Trabalhe conosco
            </a>
          </li>
          <li class="links__list-item">
            <a class="links__link" target="_blank" rel="noopener noreferrer" href="https://queroalunos.com">
              Portal do Parceiro
            </a>
          </li>
          <li class="links__list-item">
            <a class="links__link" rel="noopener" target="_blank" href="https://gestores.queroeducacao.com.br">
              Quero ser Parceiro
            </a>
          </li>
          <li class="links__list-item">
            <a class="links__link" href="mailto:imprensa@querobolsa.com.br">
              Imprensa
            </a>
          </li>
          <li class="links__list-item">
            <a class="links__link" rel="noopener" target="_blank" href="https://gestores.queroeducacao.com.br">
              Captação de Alunos
            </a>
          </li>
          <li class="links__list-item">
            App
            <a class="links__link" target="_blank" rel="noopener noreferrer" href="https://play.google.com/store/apps/details?id=com.redealumni.appquerobolsa&amp;hl=pt_BR">
              Quero Bolsa
            </a>
          </li>
        </ul>
      </b-col>
      <b-col v-show="bigScreen">
        <ul class="links__list">
          <li class="links__list-item links__list-item--header">Dicas Quero Bolsa</li>
          <li class="links__list-item">
            <a class="links__link" target="_blank" rel="noopener" href="/intercambio?utm_source=querobolsa&utm_medium=referral&utm_campaign=link-footer">Intercâmbio</a>
          </li>
          <li class="links__list-item">
            <a class="links__link" target="_blank" rel="noopener" href="https://www.melhorescola.com.br">Melhor Escola</a>
          </li>
          <li class="links__list-item">
            <a class="links__link" target="_blank" rel="noopener" href="/escolas">Vagas em escolas</a>
          </li>
          <li class="links__list-item">
            <a class="links__link" target="_blank" rel="noopener" href="/servicos-recomendados">Serviços Parceiros</a>
          </li>
          <li class="links__list-item">
            <a class="links__link" target="_blank" rel="noopener" href="https://www.querobolsa.com.br/teste-vocacional-gratis">Teste Vocacional</a>
          </li>
          <li class="links__list-item">
            <a class="links__link" target="_blank" rel="noopener" href="/carreiras/cursos-gratuitos">Cursos Gratuitos</a>
          </li>
          <li class="links__list-item">
            <a class="links__link" target="_blank" rel="noopener" href="https://pt-br.classpert.com">Cursos Online</a>
          </li>
          <li class="links__list-item">
            <a class="links__link" target="_blank" rel="noopener" href="/portal-do-aluno">Portal do Aluno</a>
          </li>
          <li class="links__list-item">
            <a class="links__link" target="_blank" rel="noopener" href="https://quero.com">quero.com</a>
          </li>
          <li class="links__list-item d-lg-none"><a class="links__link" href="/revista/">Revista Quero</a></li>
          <li class="links__list-item d-lg-none"><a class="links__link" href="/enem/manual-do-enem">Manual do Enem</a></li>
          <li class="d-lg-none"><a class="links__link" href="/enem/gabarito">Gabarito do Enem</a></li>
        </ul>
      </b-col>
      <b-col v-show="!bigScreen">
        <div>
          <ul class="links__list-items-wrapper">
            <li class="links__list-item-external">
              <a class="links__list-item-external" href="/busca-cursos/resultados">
                Busque por Curso
              </a>
            </li>
            <li class="links__list-item-external">
              <a class="links__list-item-external" href="/faculdades-e-universidades">
                Lista de Faculdades
              </a>
            </li>
            <li class="links__list-item-external">
              <a class="links__list-item-external" href="/cursos-e-faculdades">
                Lista de Cursos
              </a>
            </li>
            <li class="links__list-item-external">
              <a class="links__list-item-external" href="/carreiras-e-profissoes/todas">
                Lista de Profissões
              </a>
            </li>
            <li class="links__list-item-external">
              <a class="links__list-item-external" href="/programas-do-governo">
                Notas de corte
              </a>
            </li>
            <li class="links__list-item-external">
              <a class="links__list-item-external" href="/teste-vocacional-gratis">
                Teste Vocacional
              </a>
            </li>
            <li class="links__list-item-external">
              <a class="links__list-item-external" href="/enem">
                Enem
              </a>
            </li>
            <li class="links__list-item-external">
              <a class="links__list-item-external" href="/sisu">
                Sisu
              </a>
            </li>
            <li class="links__list-item-external">
              <a class="links__list-item-external" href="/prouni">
                Prouni
              </a>
            </li>
            <li class="links__list-item-external">
              <a class="links__list-item-external" href="/fies">
                Fies
              </a>
            </li>
            <li class="links__list-item-external">
              <a class="links__list-item-external" href="encceja">
                Encceja
              </a>
            </li>
            <li class="links__list-item-external">
              <a class="links__list-item-external" href="/perguntas-frequentes">
                Perguntas Frequentes
              </a>
            </li>
            <li class="links__list-item-external">
              <a class="links__list-item-external" href="/o-que-e-o-quero-bolsa">
                O que é o Quero Bolsa
              </a>
            </li>
          </ul>
        </div>
      </b-col>
    </b-row>
  </b-container>
</template>

<style lang="sass" scoped>
  @import '~/assets/stylesheets/utils/module.sass'

  .links
    color: $white
    padding: 0

    @media (min-width: $screen-lg-min)
      padding-bottom: $space-m
      padding-top: 54px

  .links__list
    font-size: rem(13)
    list-style: none
    margin: 0
    padding: 0
    text-align: center

    @media (min-width: $screen-md-min)
      text-align: left

    @media (min-width: $screen-lg-min)
      font-size: rem(14)


  .links__list-item
    color: $footer-color
    line-height: 22px
    font-weight: $fw-normal
    margin-bottom: $space-m

    a:hover
      color: $primary-pure

    @media (min-width: $screen-lg-min)
      margin-bottom: $space-s

  .links__list-item--header
    color: $footer-color
    font-weight: $fw-bold
    margin-bottom: $space-m
    white-space: nowrap

  .links__list-item--inline
    display: inline
    line-height: 2.31

  .links__link
    color: $footer-color

    &:hover
      color: $white
      text-decoration: none

  .links__link--inline
    color: $white
    font-weight: 500
    line-height: 10px
    padding-right: 12px

    &::before
      border-left: 1px solid $footer-color
      content: ' '
      display: inline-block
      height: 10px
      margin-right: 12px

  .links__link--first::before
    display: none

  .links__list-items-wrapper
    list-style: none
    margin: 0
    padding: $space-s 0
    width: 100%

    @media (min-width: $screen-md-min)
      padding-bottom: 0
      padding-top: 0

  .links__list-item-external
    padding-bottom: $space-s
    padding-top: $space-s

  .links__list-item-external
    color: $footer-color
    font-size: rem(13)
    line-height: rem(13)
    text-decoration: none

</style>

<script>
  export default {
    computed: {
      bigScreen() {
        return (this.$mq === 'md' || this.$mq === 'lg' || this.$mq === 'xl');
      },
    }
  }
</script>
